module.exports = __webpack_public_path__ + "resources/icon_28_comment.07ea989570bfad4b.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_comment.png
// module id = 425
// module chunks = 0 1 2 3 4